import $ from 'jquery';

class LoginController {
  constructor(AuthenticationService, $scope, $window, $timeout, $state, $http, $rootScope, $sce, $stateParams) {
    "ngInject";

    let self = this;
    this.window = $window;
    this.timeout = $timeout;
    this.scope = $scope;
    this.state = $state;
    this.loginOptions = [];
    this.apiHost = $rootScope.apiHost;
    this.$rootScope = $rootScope;
    this.authenticationService = AuthenticationService;
    this.$http = $http;
    this.credentials = {
      username: '',
      password: ''
    }

    if($stateParams.loginErrorCode) {
      $http.get($rootScope.apiHost+"/api/errors/"+$stateParams.loginErrorCode).then(
        function(response) {
          self.shake();
          self.loginErrorMessage = response.data.msg;
        });
    }

    $http.get($rootScope.apiHost+"/api/login/options").then(
      function(response) {
        self.loginOptions = response.data;
    });

  }

  loginBasic() {
      let headers = {};
      headers.authorization = "Basic " + btoa(this.credentials.username + ":" + this.credentials.password);

      if (this.scope.login_form.$valid) {
         let ctrl = this;

        this.$http.get(this.$rootScope.apiHost+"/api/users/me",{headers:headers, withCredentials: true} ).then(
          function(response) {
            if(response.data.userName){
                ctrl.authenticationService.refreshUser().then(function () {
                  ctrl.state.go("admin");
                });
            } else {
              ctrl.loginErrorMessage = 'Invalid Username/Password Combination';
              ctrl.shake();
            }
          }, function (failure) {
            ctrl.shake();
            ctrl.loginErrorMessage = 'Invalid Username/Password Combination';
          });
      } else {
          this.scope.login_form.submitted = true;
      }
  }

  shake() {
    $('#loginForm').addClass('animated shake');
    this.timeout(function () {
        $('#loginForm').removeClass('animated shake');
    },1000);
  }

  loginOauth(url) {
      self.window.location.href = this.apiHost+url;
  }

}

export default LoginController;



// WEBPACK FOOTER //
// ./client/pages/login/login.controller.js